export function timeComparator<T>(a: T, b: T, getDate: (item: T) => Date | undefined): number {
  const [ia, ib] = [getDate(a)?.getTime() ?? 0, getDate(b)?.getTime() ?? 0];
  if (ia > ib) return 1;
  if (ib > ia) return -1;
  return 0;
}
